// removed by extract-text-webpack-plugin
module.exports = {"ipLists-table":"index__ipLists-table___3pods","ipLists-icon":"index__ipLists-icon___3CKIF","ipLists-icon-active":"index__ipLists-icon-active___3Abzd","ipLists-icon-inActive":"index__ipLists-icon-inActive___CeCTP","iplists-edit-wrapper":"index__iplists-edit-wrapper___TXRIF"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Setup/IpWhiteLists/index.less
// module id = 338
// module chunks = 3